import template from './fieldEdit.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
controller: class controller {
    constructor(
      $mdDialog,
      $mdMedia,
      eventService,
      fieldService,
      uiService,
      Field,
      FieldType,
      FieldEntity,
      Color
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = () => {
        ctrl.destroyWatch = eventService.onFieldEdit((params) => {
          $mdDialog
            .show({
              targetEvent: params.event,
              locals: {
                field:
                  params.field && params.field.id
                    ? angular.copy(params.field)
                    : Field.blank(params.fieldType)
              },
              template,
              controllerAs: '$ctrl',
              controller(field) {
                const ctr = this;
                ctr.field = field;
                ctr.setButtonClasses = () => {
                  const variation = ctr.field.color.title().onlyNumbers();
                  if (variation < 300) {
                    ctr.buttonClasses = `${ctr.field.color.title()}-bg grey-800`;
                    ctr.iconClass = `grey-800`;
                  } else {
                    ctr.buttonClasses = `${ctr.field.color.title()}-bg grey-50`;
                    ctr.iconClass = `grey-50`;
                  }
                };
                ctr.isEditingField = _.isUuid(field.id);
                if (!ctr.isEditingField) {
                  ctr.field.name = ctr.field.type.title();
                  ctr.field.color = Color.of('blue_grey_300');
                }
                ctr.setButtonClasses();
                ctr.pickIcon = false;
                ctr.pickColor = false;
                ctr.iconPicked = (icon) => {
                  ctr.pickIcon = false;
                  ctr.field.icon = icon;
                };
                ctr.colorPicked = (color) => {
                  ctr.pickColor = false;
                  ctr.field.color = color;
                  ctr.setButtonClasses();
                };
                ctr.confirm = () => {
                  if (ctr.field.name !== '') {
                    ctr.field.entity = FieldEntity.ticket;
                    $mdDialog.hide(ctr.field);
                  } else {
                    uiService.toast({
                      text: {
                        p1: 'Custom Field',
                        p2: 'name',
                        p3: 'is required'
                      },
                      warn: true
                    });
                  }
                };
                ctr.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then((result) => {
              const field = result;
              if (!_.isUuid(field.id)) {
                fieldService.createField(field).then((data) => {
                  if (data.status) {
                    field.id = data.id;
                    field.isNew = true;
                    ctrl.onFinished({ field });
                    uiService.toast({
                      text: {
                        p1: 'Custom field',
                        p2: field.getName(),
                        p3: 'has been added'
                      }
                    });
                  }
                });
              } else {
                fieldService.updateField(field).then((data) => {
                  if (data.status) {
                    ctrl.onFinished({ field });
                    uiService.toast({
                      text: {
                        p1: 'Custom field',
                        p2: field.getName(),
                        p3: 'has been updated'
                      }
                    });
                  }
                });
              }
            });
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      ctrl.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      ctrl.$onDestroy = function () {
        ctrl.destroyWatch();
      };
    }
  }
};
